import { Bar, DEFAULT_LABEL, InputField, PageShell } from './primitives';

export function OrganisationEditSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <header className="flex-shrink-0 h-23 border-b border-dinnerplate-white">
        <div className="flex h-full w-full items-center px-6 sm:px-8 lg:px-16">
          <div className="flex items-center gap-2">
            <Bar className="h-5 w-[114px]" />
            <Bar className="size-3" />
            <Bar className="h-5 w-[88px]" />
            <Bar className="size-3" />
            <Bar className="h-5 w-[25px]" />
          </div>
        </div>
      </header>
      <div className="flex-1">
        <div className="w-full px-16 pt-8">
          <Bar className="h-[30px] w-48 mb-4" />
          <div className="flex flex-col gap-8">
            <div className="grid grid-cols-2 gap-6">
              <InputField />
              <InputField />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <InputField />
              <InputField />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <InputField />
              <InputField />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <InputField />
              <InputField />
            </div>
            <InputField />
          </div>
        </div>
      </div>
      <footer className="flex-shrink-0 h-23 border-t border-dinnerplate-white">
        <div className="flex h-full w-full items-center justify-end px-16">
          <Bar className="h-[45px] w-[131px] rounded-input" />
        </div>
      </footer>
    </PageShell>
  );
}
